import AMultiFieldSearchInput from 'components/AMultiFieldSearchInput/AMultiFieldSearchInput';
import React, { useEffect, useRef, useState } from 'react';
import APopover from 'views/pages/manage/common/a-popover';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import FilterForm from './FilterForm';
import ListComponent from './ListComponent';
import { Card, CardBody } from 'reactstrap';
import { bulkActionMapping, bulkActionsDropdown, createBulkRequest, notificationConfigList, statusFilterOptions } from './constant';
import AToggleButtonGroup from 'components/AToggleButtonGroup/AToggleButtonGroup';
import NotificationConfig from './NotificationConfig';
import { getDropdown } from './utils';
import { endpoint } from "../../../../views/pages/manage/common/constant"
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ALoader from 'views/pages/manage/common/a-loader';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

const RefundCompletionMaster = ({ userPermissions }) => {
    const [filterCount, setFilterCount] = useState()
    const [rows, setRows] = useState([]);
    const [status, setStatus] = useState('ALL')
    const [bulkAction, setBulkAction] = useState();
    const [dropdowns, setDropdowns] = useState();
    const [loader, setLoader] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [currPageSize, setCurrentPageSize] = useState(50)
    const [globalFilter, setGlobalFilter] = useState({})
    const [notficationConfig, setNotificationConfig] = useState()
    const ref = useRef()

    useEffect(() => {
        init()
    }, [])


    const init = async () => {
        try {
            setLoader(true)
            const res = await Promise.all([getDropdown(), getCompletionRefundList(0, 50, { status: "ALL" }), handleNotificationConfig()])
            setDropdowns((prev) => ({ ...prev, ...res[0] }))
        }
        catch (err) {
            console.error(err)
        }
        finally {
            setLoader(false)
        }
    }

    const handleNotificationConfig = async ({ id = null, status = null } = {}) => {
        let url = endpoint.refund.completionRefund.notificationConfig;

        const isUpdate = id !== null && status !== null;

        if (isUpdate) {
            url += `/${id}?status=${status}`;
        }
        const res = isUpdate ?
            await fetchAllPostPromisedData(url, {}, 'put') :
            await fetchAllPromisedData(url, true);
        if (res.code === 200) {
            if (isUpdate) {
                // After update, fetch latest config again
                await handleNotificationConfig();
            } else {
                setNotificationConfig(res?.data);
            }
        }
    };


    const getCompletionRefundList = async (page = 0, pageSize = currPageSize, reqObj = globalFilter) => {
        try {
            setLoader(true)
            const url = `${endpoint.refund.completionRefund.search}?offset=${page}&limit=${pageSize}`
            const updatedReq= reqObj?.status == "ALL" ? {...reqObj, status: null} : reqObj;
            const data = await fetchAllPostPromisedData(url, updateRequest(updatedReq))

            if (data?.code == 200) {
                debugger
                const rowList = data?.data?.paginatedData;
                 setGlobalFilter(updatedReq);
                // const responseListKey = responseListKeyMapping?.[selectedTab?.key]
                // const rowList = processRowList(data?.data?.[responseListKey] ?? [], dropdown?.[selectedTab?.key])
                setRows((rowList).map((item, index) => ({ ...item, srNo: index + 1 })))
                setRowCount(data?.data?.totalRecords)
                setCurrentPage(page)
                setCurrentPageSize(pageSize);
               
            }
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoader(false)
        }
    }

const statusFilterChangeHandler = (statusValue) => {
    const updatedFilter = { ...globalFilter, status: statusValue };
    setStatus(statusValue);
    getCompletionRefundList(0, currPageSize, updatedFilter);
};
    const createUpdateHandler = async (rowForm, action) => {
        try {
            setLoader(true);
            const reqObj = {
                ...updateRequest(rowForm),
                "blockRfidEnabled": action == 'blockRFID' ? true : rowForm?.blockRfidEnabled,
                "cronEnabled": action == 'autoInitiate' ? true : rowForm?.cronEnabled
            }


            const url = `${endpoint?.refund.completionRefund.update}/${reqObj?.id}`;
            const method = 'put'

            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                getCompletionRefundList();
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.error(err);
        }
        finally {
            setLoader(false)
        }
    }
    const bulkApplyHandler = async (selectedRow, bulkAction) => {
        const req = createBulkRequest(selectedRow, bulkAction);
        try {
            setLoader(true)
            const res = await fetchAllPostPromisedData(endpoint.refund.completionRefund.bulk, req)
            if (res.code == 200) {
                successToast(res?.message)
                await getCompletionRefundList(0, currPageSize)
            }
        }
        catch (err) {

        }
        finally {
            setLoader(false)
        }
    }
    return (
        <>
            {loader && <ALoader position="fixed" />}
            <Card className='ml-3 mr-3'>
                <CardBody>
                    <div className=" d-flex heading-4 color-dark align-items-center justify-content-between "
                    //   style={headerStyle}
                    >

                        <div className=""> Completion refund & RFID control</div>
                        <div className='d-flex align-items-start justify-content-center'>

                            <div className='ml-3'>
                                <AToggleButtonGroup
                                    options={statusFilterOptions}
                                    defaultSelected={'ALL'}
                                    allowDeselect={false}
                                    changeHandler={statusFilterChangeHandler}
                                />
                            </div>
                            <APopover
                                buttonComponent={(openPopover, styles) => (
                                    <AButton
                                        className="tiny-semi-bold color-dark"
                                        onClick={openPopover}
                                        size="xs"
                                        updatedStyle={{
                                            minWidth: "61px",
                                            ...(filterCount > 0
                                                ? {
                                                    border: "1px solid #00B0F5",
                                                    color: "#00B0F5",
                                                }
                                                : styles),
                                        }}
                                    >
                                        Filters {filterCount > 0 ? `(${filterCount})` : ""}
                                        {/* {filterCount > 0 ? `(${filterCount})` : ""} */}
                                    </AButton>
                                )}
                                menuComponent={(closePopup) =>
                                    <FilterForm
                                        closePopup={closePopup}
                                        dropdownData={dropdowns}
                                        globalFilter={globalFilter}
                                        setGlobalFilter={setGlobalFilter}
                                        searchHandler={getCompletionRefundList}
                                        filterCount={filterCount}
                                        setFilterCount={setFilterCount}
                                        currPageSize ={currPageSize}
                                        currentPage ={currentPage}
                                    />
                                }
                            />
                            <APopover
                                buttonComponent={(openPopover, styles) => (
                                    <AButton
                                        className="tiny-semi-bold color-dark mr-2"
                                        onClick={openPopover}
                                        size="xs"
                                        updatedStyle={{
                                            styles
                                        }}
                                    >
                                        <span className='d-flex justify-content-center align-items-center' style={{ gap: '10px' }}> Notification config </span>
                                    </AButton>
                                )}
                                menuComponent={(closePopup) =>
                                    <NotificationConfig userPermissions={userPermissions} closeForm={closePopup} notificationConfig={notficationConfig} handleNotificationConfig={handleNotificationConfig} />
                                }
                            />
                        </div>
                    </div>
                    <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                    <ListComponent
                        userPermissions={userPermissions}
                        rows={rows}
                        status={status}
                        bulkAction={bulkAction}
                        setBulkAction={setBulkAction}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        loader={loader}
                        setLoader={setLoader}
                        rowCount={rowCount}
                        currPageSize={currPageSize}
                        setCurrentPageSize={setCurrentPageSize}
                        createUpdateHandler={createUpdateHandler}
                        ref={ref}
                        bulkApplyHandler={bulkApplyHandler}
                        getCompletionRefundList={getCompletionRefundList}
                    />
                </CardBody>
            </Card>

        </>
    );
}

export default RefundCompletionMaster;